export type PhotoLens = '0.5x' | '1x' | '2x' | '5x';

export const PHOTO_LENSES: PhotoLens[] = ['0.5x', '1x', '2x', '5x'];

const PHOTO_LENS_FOV_FACTOR: Record<PhotoLens, number> = {
  '0.5x': 1.55,
  '1x': 1,
  '2x': 0.56,
  '5x': 0.26,
};

export function photoLensLabel(lens: PhotoLens): string {
  return lens;
}

export function photoLensToFov(baseFov: number, lens: PhotoLens): number {
  const raw = baseFov * PHOTO_LENS_FOV_FACTOR[lens];
  return Math.max(14, Math.min(92, raw));
}
